import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useSearchParams } from "react-router-dom";
import { useMerchantContext } from "lib/contexts/MerchantProvider";

interface OverlaySpinnerProps {
  // for future use
}

const OverlaySpinner: React.FC<OverlaySpinnerProps> = () => {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page")?.toLowerCase();
  const isCartPage = ["cart", "empty-cart"].includes(page ?? "");
  const {
    state: { cartMetadata },
  } = useMerchantContext();
  const pageBackgroundColor = isCartPage
    ? cartMetadata?.uiAttributes?.page?.backgroundColor ?? ""
    : "";
  return (
    <OverlayPortal>
      <div className="fixed inset-0 z-[100] h-screen w-full pointer-events-auto">
        <div className="h-full w-full bg-gray-lightest opacity-30" style={{ backgroundColor: pageBackgroundColor }}></div>
        <div className="fixed left-0 right-0 top-0 h-[3px] overflow-hidden">
          <div className="progress left-right h-full w-full bg-primary-dark"></div>
        </div>
      </div>
    </OverlayPortal>
  );
};

export default OverlaySpinner;

const OverlayPortal = ({ children }: { children: React.ReactElement }) => {
  let [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);
  const portalWrapper = document.getElementById("flo-overlay-portal");

  if (!mounted || !portalWrapper) return null;
  return createPortal(children, portalWrapper);
};
